import { setTerm } from './helpers';

export const setPossessor = setTerm('suburban_offer_filter');
